<span class="hyperlink"  [ngClass]="{'menu-overlay':hasOverlay,'scrolled':scrolled}" (click)="onNavItemClick()" *ngIf="navigationItem.children?.length">{{navigationItem.title}}</span>
<a class="hyperlink"  [ngClass]="{'menu-overlay':hasOverlay,'scrolled':scrolled}" [routerLink]="navigationItem.url" *ngIf="!navigationItem.children?.length">{{navigationItem.title}}</a>
<div class="navigation-items" #NavigationItems [ngClass]="{'show':navigationItem.show}">
  <div class="grid grid-section navigation-items-header">
    <div class="mobile-back-button" (click)="onNavItemClick()">< <span i18n="@@Return">Retour</span></div>
    <div class="navigation-items-title">{{navigationItem.title}}</div>
    <div class="navigation-items-close button button-outline-white" (click)="onNavItemClick()"><i class="ai-cross"></i> <span i18n="@@Close">Fermer</span></div>
  </div>
  <div class="grid grid-section navigation-items-content" [ngClass]="{'content-show':navigationItem.show}">
    <ul [ngClass]="{'show':navigationItem.show}" *ngIf="navigationItem.show">
      <ng-container *ngTemplateOutlet="submenu;context: {$implicit : navigationItem.children}" ></ng-container>
    </ul>
  </div>
</div>

<ng-template #submenu let-menu>
  <li *ngFor="let subNavigationItem of menu" [ngClass]="{'active':subNavigationItem.show}">
    <div class="mobile-back-button" *ngIf="subNavigationItem.children" (click)="onBackItemClick(subNavigationItem)">< <span i18n="@@Return">Retour</span></div>
    <span class="hyperlink" [ngClass]="{'active':subNavigationItem.show}" (click)="onSubNavItemClick(subNavigationItem,menu)" *ngIf="subNavigationItem.children?.length">{{subNavigationItem.title}}</span>
    <a class="hyperlink" [ngClass]="{'active':subNavigationItem.show}" [routerLink]="subNavigationItem.url" *ngIf="!subNavigationItem.children?.length">{{subNavigationItem.title}}</a>
    <ul [ngClass]="{'show':subNavigationItem.show}" *ngIf="subNavigationItem.children">
      <ng-container *ngTemplateOutlet="submenu; context: {$implicit:subNavigationItem.children}" ></ng-container>
    </ul>
  </li>
</ng-template>
